import { forwardRef, useState, useContext } from "react";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOut, faPen, faUser } from "@fortawesome/free-solid-svg-icons";
import { getAuth, signOut } from "firebase/auth";
import firebaseConfig from "@serie3/freelancesplaceapi/Config/Firebase/firebase";
import { initializeApp } from "firebase/app";
import { useNavigate } from "react-router-dom";
import SystemProfileContext from "@serie3/common/user/SystemProfileContext";

const AvatarToggle = forwardRef(({ onClick }, ref) => {
  const { systemProfile } = useContext(SystemProfileContext);
  const firstName = systemProfile?.vorname || "";
  const initials = firstName ? firstName[0].toUpperCase() : "U";
  const [hovered, setHovered] = useState(false);

  return (
    <button
      ref={ref}
      onClick={(e) => { e.preventDefault(); onClick(e); }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "flex", alignItems: "center", gap: "8px",
        background: hovered ? "#f5f9ff" : "transparent",
        border: "none", borderRadius: "10px",
        padding: "5px 10px 5px 6px",
        cursor: "pointer", transition: "background 0.15s",
      }}
    >
      <div style={{
        width: "32px", height: "32px", borderRadius: "50%",
        background: "linear-gradient(135deg, #1a73e8, #0d47a1)",
        color: "#fff", display: "flex", alignItems: "center",
        justifyContent: "center", fontWeight: 700, fontSize: "0.85rem", flexShrink: 0,
      }}>
        {initials}
      </div>
      <span style={{ fontSize: "0.85rem", fontWeight: 600, color: "#424242" }}>
        {firstName || "Profile"}
      </span>
    </button>
  );
});

const menuStyle = {
  borderRadius: "12px",
  boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
  border: "1px solid #f0f0f0",
  padding: "8px",
  minWidth: "180px",
  marginTop: "6px",
};

const itemStyle = (color = "#424242") => ({
  display: "flex", alignItems: "center", gap: "10px",
  padding: "9px 12px", borderRadius: "8px",
  fontSize: "0.88rem", fontWeight: 500, color, cursor: "pointer",
});

const iconBox = (bg, color) => ({
  width: "28px", height: "28px", borderRadius: "7px",
  background: bg, color, display: "flex", alignItems: "center",
  justifyContent: "center", fontSize: "0.75rem", flexShrink: 0,
});

const ProfileDropdown = () => {
  const navigate = useNavigate();
  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);

  return (
    <Dropdown as="li" style={{ listStyle: "none" }}>
      <Dropdown.Toggle as={AvatarToggle} />
      <Dropdown.Menu style={menuStyle} align="end" popperConfig={{ strategy: "fixed" }} renderOnMount>
        <Dropdown.Item as="div" style={itemStyle()} onClick={() => navigate("/userprofile")}>
          <span style={iconBox("#e8f0fe", "#1a73e8")}>
            <FontAwesomeIcon icon={faPen} />
          </span>
          Edit Profile
        </Dropdown.Item>
        <div style={{ height: "1px", background: "#f5f5f5", margin: "4px 0" }} />
        <Dropdown.Item as="div" style={itemStyle("#c62828")} onClick={() => signOut(auth)}>
          <span style={iconBox("#ffebee", "#c62828")}>
            <FontAwesomeIcon icon={faSignOut} />
          </span>
          Logout
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
